var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16933",
    "data-name": "Grupo 16933",
    transform: "translate(-781 -238)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_67",
    "data-name": "Elipse 67",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(781 238)",
    fill: "#4663ab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16694",
    "data-name": "Grupo 16694",
    transform: "translate(787.956 241.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_326",
    "data-name": "Caminho 326",
    d: "M1.01-1.789H3V-8.5H1.01ZM2-9.483a1.054,1.054,0,0,0,1.149-1.041A1.044,1.044,0,0,0,2-11.552,1.052,1.052,0,0,0,.848-10.524,1.062,1.062,0,0,0,2-9.483Z",
    transform: "translate(-0.848 11.552)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoInfo);
export default __webpack_public_path__ + "static/media/ico-info.149976e330eaa84e227c9ce472109a5a.svg";
export { ForwardRef as ReactComponent };